import { Storage } from '@mancala/core'

export class LocalStorage implements Storage {
    getString(key: string): string | undefined {
        return localStorage.getItem(key) as string;
    }
    setString(key: string, value: string): void {
        localStorage.setItem(key, value);
    }
    deleteString(key: string): void {
        localStorage.removeItem(key);
    }
}